import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import {
  getInvoiceItem,
  getServices,
  getSpecificInvoice,
} from "../../actions/invoiceItem";
import { getInvoiceMeasurement } from "../../actions/measurment";
import { getBusinessProfile } from "../../actions/settings";
import { getSpecificLocation } from "../../actions/warehouseAction";
import Barcode from "react-barcode";

import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  Button,
  Col,
  Row,
  Select,
  message,
  TreeSelect,
  Space,
  Divider,
  Drawer,
  Image,
  Skeleton,
} from "antd";
import { result } from "lodash";
import moment from "moment";

const { Option } = Select;

const Quickview = ({
  id,
  getInvoiceItem,
  getServices,
  getBusinessProfile,
  businessprofile,
  getInvoiceMeasurement,
  getSpecificInvoice,
  getSpecificLocation,
}) => {
  var formatter = new Intl.NumberFormat("en-IN");
  const componentRef = useRef();
  const [visible, setVisible] = useState(false);
  const [loading, setloading] = useState(true);
  const [branch, setbranch] = useState([]);
  const [data, setdata] = useState([]);
  const [details, setdetails] = useState([]);
  const [measurements, setmeasurements] = useState([]);
  const [services, setservices] = useState([]);
  const count = useRef(0);
  const serialcount = useRef(0);
  const formattedCreatedDate = moment(details.created_at).format("DD-MM-YYYY HH:mm:ss");

  const subtotal = parseFloat(details.additional_discount) + parseFloat(details.spec_item_discount) + parseFloat(details.discount) + parseFloat(details.bill);
  console.log(subtotal);
  console.log(typeof(subtotal));
  // console.log(typeof(details.additional_discount));
  // console.log(typeof(details.spec_item_discount));
  // console.log(typeof(details.discount));
  // console.log(typeof(details.bill));

  useEffect(() => {
    getSpecificInvoice(id).then((result) => {
      setdetails(result);
      console.log(result);
      getSpecificLocation(result.location).then((r) => {
        setbranch(r);
      });
    });
    getInvoiceItem(id).then((e) => {
      getBusinessProfile();
      getServices(id).then((service) => {
        getInvoiceMeasurement(id).then((result) => {
          if (result.length > 0) {
            setmeasurements(result[0]);
          } else {
            setmeasurements(false);
          }
          console.log(measurements);
          count.current = e.length + service.length;
          if (count.current < 10) count.current = 10 - count.current;
          else {
            count.current = 0;
          }
          setdata([...e, ...service]);

          setloading(false);
          setservices(service);

          // Auto Print after POS submit
          setTimeout(function() { //Start the timer
            document.getElementById("yo-print").click(); //After 1 second, set render to true
          }.bind(this), 500)
          
        });
      });
    });
  }, []);

  // FOR AUTO PRINT IN ENTER
  useEffect(() => {
    const handleKeyPress = (event) => {
      // alert("enter bahire")
      if (event.key === "Enter") {
        // printAction();
        // alert("Enter")
        document.getElementById("yo-print").click();
      }
    };

    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  const printAction = () => {
    if (componentRef.current) {
      ReactToPrint.print(componentRef.current);
    }
  };

  const onClose = () => {
    setVisible(false);
  };
  const renderImage = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return (
        <img
          src={businessprofile.logo}
          style={{
            width: "60%",
            right: "0",
          }}
        />
      );
    }
  };
  const renderitems = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return data.map((item, index) => {
        console.log(item);
        serialcount.current = index + 1;
        return (
          <>
            <tr>
              <td>{index + 1}</td>
              {item.details ? (
                <td>
                  {" "}
                  <div
                    className="d-div"
                    dangerouslySetInnerHTML={{ __html: item.Product[0].Deatils[0].product_code  }} 
                  ></div>--{item.Product[0].Attribute_details}
                </td>
              ) : (
                <td> {item.Product[0].Deatils[0].product_code} -- {item.Product[0].Attribute_details}</td>
              )}
              {/* {item.details ? (
                <td></td>
              ) : (
                <td> {item.Product[0].Deatils[0].product_code}</td>
              )} */}

              <td>{formatter.format(item.price)}</td>

              <td style={{ textAlign: "center", margin: "auto" }}>
                {item.quantity}
              </td>
              {/* <td style={{ textAlign: "center", margin: "auto" }}>
                {item.spec_discount}
              </td> */}
              <td
                style={{
                  textAlign: "center",
                  margin: "auto",
                  paddingRight: "5px",
                }}
              >
                {formatter.format(item.price * item.quantity - item.spec_discount)}
              </td>
            </tr>
          </>
        );
      });
    }
  };

  const renderblanktables = () => {
    if (loading) {
      return "";
    } else {
      let indexcount = 0;
      return Array.apply(null, Array(count.current)).map(() => {
        indexcount = indexcount + 1;
        return (
          <tr>
            <td>{serialcount.current + indexcount}</td>
            {/* <td></td> */}
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        );
      });
    }
  };

  if (loading) {
    return <Skeleton active />;
  } else {
    return (
      <>
        <ReactToPrint
          trigger={() => <button id="yo-print">Print this out!</button>}
          content={() => componentRef.current}
        />
        <div style={{ display: "block" }}>
          <div ref={componentRef} style={{ padding: "10px" }}>
            <Row
              className="invoice_print_fontSize"
              style={{
                // borderBottom: "2px solid lightgray",
                marginTop: "2px",

                paddingBottom: "2px",
              }}
            >
              <Col span={24} style={{ textAlign: "center" }}>

                {renderImage()}
                <div style={{ fontSize: "30px", fontWeight: 700, letterSpacing: "4px",}}>
                    {/* <b>{branch.CompanyName}</b> */}
                    {/* <b>{businessprofile.business_name}</b> */}
                  </div>
                {/* <h2 style={{ fontSize: "80px", fontWeight: 700 }}><b>{branch.CompanyName}</b></h2> */}
                {/* <div style={{ fontSize: "18px", fontWeight:"800" }}>{details.Location[0].name}</div> */}
                {/* <br></br> */}
                {/* {details.Location[0].address} */}
                {/* <div style={{marginTop:"-30px"}}
                  className="d-div"
                  dangerouslySetInnerHTML={{
                    __html: details.Location[0].address,
                  }}
                ></div> */}

                <div className="d-div" 
                    dangerouslySetInnerHTML={{__html: details.Location[0].address,}}
                  >
                </div>
                <div className="d-div" 
                    dangerouslySetInnerHTML={{__html: businessprofile.social_link,}}
                  >
                </div>
                {/* <p> Website: </p> */}
                <div style={{ borderWidth: 2, borderStyle: 'solid', borderColor: '#303338', marginBottom: "5px" }}></div>
                {/* <br></br>
                  {branch.name}
                  <br></br>
                  {branch.address}
                  {console.log(branch)} */}
              </Col>
              <Col span={24} style={{ marginTop: "10px" }}>
                {/* MUSHAK 6.3<br></br> */}
                INVOICE N0.{" "}
                {details.invoice_number ? (
                  <b>{details.invoice_number}</b>
                ) : (
                  ""
                )}{" "}
                {/*<br></br> ORDER NO.{" "}
                  {details.order_number ? <b>{details.order_number}</b> : ""} */}
                <br></br>
                CALL/CONTACT : <b>{details.Location[0].contact}</b>{" "}
                <br></br>
                {details.created_at ? (
                    <>
                      ISSUE DATE : {formattedCreatedDate}
                      <br></br>
                    </>
                  ) : (
                    ""
                )}
                {/* {details.delivery_date ? (
                  <>
                    DELIVERY DATE : {details.delivery_date}
                    <br></br>
                  </>
                ) : (
                  ""
                )} */}
                {/* {details.program_date ? (
                  <>PROGRAM DATE : {details.program_date}</>
                ) : (
                  ""
                )} */}
              </Col>
              {details.contact ? (
                <>
                  <Row>
                    <Col span={24}>
                      {details.Contact[0].name ? (
                        <>CUSTOMER NAME : {details.Contact[0].name}<br></br></>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col span={24}>
                      {details.Contact[0].phone ? (
                        <>CUSTOMER CONTACT : {details.Contact[0].phone}<br></br></>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      {details.Contact[0].address ? (
                        <>ADDRESS : {details.Contact[0].address}<br></br></>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                  {/* <Row>
                    <Col span={24}>
                      {details.shipping_address ? (
                        <>SHIPPING ADDRESS : {details.shipping_address}</>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row> */}
                </>
              ) : (
                <></>
              )}
            </Row>
            <br></br>
            <Row>
              <Col span={24}>
                <table className="product_table invoice_print_fontSize">
                  <tbody>
                    <tr style={{ fontWeight: "500", border: "2px" }}>
                      <td>SL</td>
                      <td>Details</td>
                      {/* <td>DESIGN CODE</td> */}
                      <td>M.R.P</td>
                      <td>Qty</td>
                      {/* <td>Disc</td> */}
                      <td style={{ textAlign: "center" }}>TOTAL</td>
                    </tr>
                    {renderitems()}
                    {/* {renderservices()} */}
                    {/* {renderblanktables()} */}
                  </tbody>
                </table>

                <Row>
                  <Col className="invoice_print_fontSize"
                    span={12}
                    style={{ textAlign: "left", marginTop: "20px" }}
                  >
                    <div style={{ fontSize: "20px" }}>Method: </div>
                    {details.payment_methods && details.payment_methods.length > 0 ? (
                      details.payment_methods.map((payment, index) => (
                        <div key={index} style={{ marginTop: "5px" }}>
                          {payment.method}: {formatter.format(payment.amount)}
                        </div>
                      ))
                    ) : (
                      <div style={{ fontSize: "20px", fontWeight: "600" }}>
                        {details.Payment_method}
                      </div>
                    )}
                  </Col>
                  <Col
                    span={12}
                    className="invoice_print_fontSize"
                    style={{
                      textAlign: "right",
                      marginTop: "20px",
                    }}
                  >
                    {/* {details.tax > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            VAT (Inclusive)
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill ">
                              {formatter.format(details.tax)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )} */}
                    {/* {details.delivery_charge > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            DELIVERY CHARGE
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.delivery_charge)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )} */}

                    <Row>
                      <Col span={18} style={{ margin: "auto" }}>
                        Sub Total
                      </Col>
                      <Col span={5} offset={1}>
                        <span className="order_span_bill">{formatter.format(subtotal)}</span>
                      </Col>
                    </Row>

                    {/* Sales Discount  */}
                    {details.additional_discount > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            Additional Disc
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.additional_discount)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}

                    {details.spec_item_discount > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            Product Disc
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.spec_item_discount)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}
                    
                    {/* Product Based Discount */}
                    {details.discount > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            Sales Disc
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.discount)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}

                    <Row>
                      <Col span={18} style={{ margin: "auto" }}>
                        Total Amount
                      </Col>
                      <Col span={5} offset={1}>
                        <span className="order_span_bill">
                          {formatter.format(details.bill)}
                        </span>
                      </Col>
                    </Row>

                    {/* <Row>
                      <Col span={18} style={{ margin: "auto" }}>
                        Receive
                      </Col>
                      <Col span={5} offset={1}>
                        <span className="order_span_bill">
                          {formatter.format(details.receive)}
                        </span>
                      </Col>
                    </Row> */}
                    <Row>
                      <Col span={18} style={{ margin: "auto" }}>
                        Payment
                      </Col>
                      <Col span={5} offset={1}>
                        <span className="order_span_bill">
                          {formatter.format(details.payment)}
                        </span>
                      </Col>
                    </Row>
                    {details.due > 0 ? (
                      <Row>
                        <Col span={18} style={{ margin: "auto" }}>
                          DUE
                        </Col>
                        <Col span={5} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(details.due)}
                          </span>
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}
                    {details.refund > 0 ? (
                      <Row>
                        <Col span={18} style={{ margin: "auto" }}>
                          Change
                        </Col>
                        <Col span={5} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(details.refund)}
                          </span>
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}

                  </Col>
                </Row>
              </Col>
            </Row>

            <h4 style={{ fontWeight: '800', fontSize: '14px', marginTop: '5px' }}>TERMS & CONDITIONS:</h4>
            
                {/* <div style={{ 
                  fontWeight: '600', 
                  marginBottom: "12px", 
                  // fontSize: '20px',
                  marginLeft: "20px"
                }}
                  // className="d-div" 
                  className="invoice_print_fontSize"
                  dangerouslySetInnerHTML={{
                    __html: businessprofile.invoice_terms,
                  }}
                ></div> */}
                <ul>
                  <li style={{ fontWeight: '600', fontSize: "14px"}}>1. Product Can Be Exchanged Within Intact Condition</li>
                  <li style={{ fontWeight: '600', fontSize: "14px"}}>2. Under Any Circumstances Can Any Amount Be Refunded</li>
                  <li style={{ fontWeight: '600', fontSize: "14px"}}>3. Invoice must be brought for exchanging product</li>
                </ul>
              
            <Row style={{margin: "auto"}}> 
              <Col span={16}><Barcode value={details.invoice_number} width={3} height={30} format="CODE128"/></Col>
              <Col span={2}></Col>            
              <Col span={2}></Col>
            </Row>

            <div style={{ borderWidth: 2, borderStyle: 'solid', borderColor: '#303338' }}></div>
           
              <div style={{ fontWeight: '700', fontSize: "14px", marginTop: "10px", }}>Powered by: THE ICT HUB</div>
              {/* <br></br> */}
              <div style={{ fontWeight: '700', fontSize: "14px",marginBottom:"10px" }}>Visit: https://theicthub.com</div>
          
          </div>
        </div>

        {/* SECONDARY */}
        <div>
          <div style={{ padding: "10px" }}>
            <Row
              // className="invoice_print_fontSize"
              style={{
                // borderBottom: "2px solid lightgray",
                marginTop: "10px",
                paddingBottom: "5px",
              }}
            >
              <Col span={24} style={{ textAlign: "center" }}>
                {renderImage()}
                {/* <h2 style={{ fontSize: "30px", fontWeight: 700 }}><b>{branch.CompanyName}</b></h2> */}
                {/* <b>{details.Location[0].name}</b> */}
                {/* <br></br> */}
                {/* {details.Location[0].address} */}
                {/* <div style={{ fontSize: "30px", fontWeight: 700, letterSpacing: "4px",}}>
                   
                    <b>{businessprofile.business_name}</b>
                  </div> */}
                <div
                  className="d-div"
                  dangerouslySetInnerHTML={{
                    __html: details.Location[0].address,
                  }}
                ></div>
                <div className="d-div" 
                    dangerouslySetInnerHTML={{__html: businessprofile.social_link,}}
                  >
                  </div>
                {/* <br></br>
                  {branch.name}
                  <br></br>
                  {branch.address}
                  {console.log(branch)} */}
              </Col>
              <Col span={24}>
                {/* MUSHAK 6.3<br></br> */}
                INVOICE N0.{" "}
                {details.invoice_number ? (
                  <b>{details.invoice_number}</b>
                ) : (
                  ""
                )}{" "}
                {/*<br></br> ORDER NO.{" "}
                  {details.order_number ? <b>{details.order_number}</b> : ""} */}
                <br></br>
                CALL/CONTACT : <b>{details.Location[0].contact}</b>{" "}
                <br></br>
                {details.created_at ? (
                    <>
                      ISSUE DATE : {formattedCreatedDate}
                      <br></br>
                    </>
                  ) : (
                    ""
                )}
                {details.delivery_date ? (
                  <>
                    DELIVERY DATE : {details.delivery_date}
                    <br></br>
                  </>
                ) : (
                  ""
                )}
                {details.program_date ? (
                  <>PROGRAM DATE : {details.program_date}</>
                ) : (
                  ""
                )}
              </Col>
              {details.contact ? (
                <>
                  <Row>
                    <Col span={24}>
                      {details.Contact[0].name ? (
                        <>CUSTOMER NAME : {details.Contact[0].name}</>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col span={24}>
                      {details.Contact[0].phone ? (
                        <>CUSTOMER CONTACT : {details.Contact[0].phone}</>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      {details.Contact[0].address ? (
                        <>ADDRESS : {details.Contact[0].address}</>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      {details.shipping_address ? (
                        <>SHIPPING ADDRESS : {details.shipping_address}</>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </>
              ) : (
                <></>
              )}
            </Row>
            <br></br>
            <Row>
              <Col span={24}>
                <table className="product_table ">
                  <tbody>
                    <tr style={{ fontWeight: "500" }}>
                      <td>SL</td>
                      <td>PRODUCT DETAILS</td>
                      {/* <td>DESIGN CODE</td> */}
                      <td>M.R.P</td>
                      <td>QTY</td>
                      {/* <td>DISC</td> */}
                      <td style={{ textAlign: "right" }}>TOTAL</td>
                    </tr>
                    {renderitems()}
                    {/* {renderservices()} */}
                    {/* {renderblanktables()} */}
                  </tbody>
                </table>
                <Row>
                  <Col className="invoice_print_fontSize"
                    span={12}
                    style={{ textAlign: "left", marginTop: "20px" }}
                  >
                    <div style={{ fontSize: "20px" }}>Method: </div>
                    {details.payment_methods && details.payment_methods.length > 0 ? (
                      details.payment_methods.map((payment, index) => (
                        <div key={index} style={{ marginTop: "5px" }}>
                          {payment.method}: {formatter.format(payment.amount)}
                        </div>
                      ))
                    ) : (
                      <div style={{ fontSize: "20px", fontWeight: "600" }}>
                        {details.Payment_method}
                      </div>
                    )}
                  </Col>
                  <Col
                    span={12}
                    // className="invoice_print_fontSize"
                    style={{
                      textAlign: "right",
                      marginTop: "5px",
                    }}
                  >
                    {/* {details.tax > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            VAT (Inclusive)
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.tax)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )} */}
                    {details.delivery_charge > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            DELIVERY CHARGE
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.delivery_charge)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}

                    <Row>
                      <Col span={18} style={{ margin: "auto" }}>
                        Sub Total
                      </Col>
                      <Col span={5} offset={1}>
                        <span className="order_span_bill">{formatter.format(subtotal)}</span>
                      </Col>
                    </Row>

                    {details.discount > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            Sales Disc
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.discount)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}

                      {details.spec_item_discount > 0 ? (
                      <>
                        <Row>
                          <Col span={18} style={{ margin: "auto" }}>
                            Product Disc
                          </Col>
                          <Col span={5} offset={1}>
                            <span className="order_span_bill">
                              {formatter.format(details.spec_item_discount)}
                            </span>
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}

                    <Row>
                      <Col span={18} style={{ margin: "auto" }}>
                        TOTAL AMOUNT
                      </Col>
                      <Col span={5} offset={1}>
                        <span className="order_span_bill">
                          {formatter.format(details.bill)}
                        </span>
                      </Col>
                    </Row>

                    <Row>
                      <Col span={18} style={{ margin: "auto" }}>
                        RECEIVE
                      </Col>
                      <Col span={5} offset={1}>
                        <span className="order_span_bill">
                          {formatter.format(details.receive)}
                        </span>
                      </Col>
                    </Row>
                    {details.due > 0 ? (
                      <Row>
                        <Col span={18} style={{ margin: "auto" }}>
                          DUE
                        </Col>
                        <Col span={5} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(details.due)}
                          </span>
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}
                    {details.refund > 0 ? (
                      <Row>
                        <Col span={18} style={{ margin: "auto" }}>
                          CHANGE
                        </Col>
                        <Col span={5} offset={1}>
                          <span className="order_span_bill">
                            {formatter.format(details.refund)}
                          </span>
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    businessprofile: state.settings.businessprofile,
  };
};

export default connect(mapStateToProps, {
  getInvoiceItem,
  getServices,
  getBusinessProfile,
  getInvoiceMeasurement,
  getSpecificInvoice,
  getSpecificLocation,
})(Quickview);
